import Sortable from 'sortablejs';

const sortableInit = (list) => {
  Sortable.create(list, {
    onEnd: onEnd,
    animation: 150,
    delay: 150,
    delayOnTouchOnly: true,
    ghostClass: "sortable--placeholder",
    chosenClass: "sortable--chosen-item",
    dragClass: "sortable--dragged-item",
    draggable: ".sortable--draggable-item",
    filter: ".sortable--non-draggable-item",
    group: list.dataset.sortableGroup || null,
    swapThreshold: list.dataset.swapThreshold || 1,
    invertSwap: list.dataset.invertSwap || false,
    invertedSwapThreshold: list.dataset.invertedSwapThreshold || list.dataset.swapThreshold || 1
  });

  addSortableItemClass(list);
}

const onEnd = (event) => {
  event.target.dispatchEvent(new CustomEvent('sortable:dropped', { detail: event }));
}

const addSortableItemClass = (list) => {
  Array.from(list.children).forEach((item) => {
    if (item.hasAttribute('data-sortable-ignore')) {
      item.classList.add('sortable--non-draggable-item');
    }
    else {
      item.classList.add('sortable--draggable-item');
    }
  });
}

const attachAll = () => {
  document.querySelectorAll('[data-toggle="sortable"]').forEach((list) => {
    sortableInit(list);
  });

  const observer = new MutationObserver((mutations) => {
    mutations.filter((m) => m.addedNodes.length > 0).forEach((mutation) => {
      // Init the mutation target if it happens to be sortable
      if (mutation.target.dataset.toggle === "sortable") {
        addSortableItemClass(mutation.target);
      }
      // Now let's look inside of what changed, and re-init them if they are sortable.
      mutation.target.querySelectorAll('[data-toggle="sortable"]').forEach((list) => {
        addSortableItemClass(list);
      });
    })
  })

  observer.observe(document.body, { childList: true, subtree: true })
}

export default { attachAll }
